module.exports = __webpack_public_path__ + "static/media/twiter.d3696384.webp";